import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';

const ContextSix = () => {
    return (
        <div className="App">
            <div className="App-body">
                <div className="email">
                    <div className="email-header">
                        <div className="email-to">
                            To: New York Times
                        </div>
                        <div className="email-from">
                            From: Anonymous
                        </div>
                        <div className="email-subject">
                            Subject: Urgent: A Call for Transparency and Justice at Globex Corporation
                        </div>
                        <div className="email-attachments">
                            Attachments: EcoBreach_Report_2021.pdf, Project_Icefire_ExecSummary.docx, GlobalInfluence_Strategy2025.ppt, ResourceWar_Gameplan.xls, CarbonShadowLeaks.txt
                        </div>
                    </div>
                    <div className="email-body">
                        I am reaching out to you not on my own behalf, but to honor the last wishes of a courageous whistleblower, 
                        Nina, a former insider at Globex Corporation. Nina dedicated her final days to documenting the wrongful 
                        acts she witnessed at Globex but tragically passed away before she could see justice pursued. <br/><br/>

                        Globex has long presented itself as a leader in sustainability and ethical business practices. However, 
                        their operations tell a different story—one of devastating environmental impact and profound human rights 
                        violations. Their involvement in land mining and relentless pursuit of fossil fuel reserves have not only 
                        scarred the earth but also displaced countless communities, stripping them of their lands and 
                        livelihoods under the guise of economic development. <br/><br/>

                        Nina's time at Globex was marred by a constant moral conflict. She was disillusioned by witnessing the 
                        company's upper management manipulate contracts and exploit legal loopholes for profit. The projects she 
                        was assigned to—ostensibly aimed at 'environmental assessment'—were nothing more than a cover to pacify 
                        regulatory bodies and press ahead with destructive operations. <br/><br/>

                        This communication is laden with evidence that Nina meticulously compiled, detailing internal memos, project 
                        reports, and communications that reveal the true extent of Globex's misconduct. Each document underscores 
                        the company's blatant disregard for environmental regulations and human rights. <br/><br/>

                        I urge you to bring these truths to light. The attached files contain documents that corroborate every claim. 
                        I trust in your commitment to justice and your ability to convey this story with the gravity it demands. <br/><br/>

                        Sincerely, <br/><br/>

                        A Concerned Friend and Former Colleague
                    </div>
                </div>
                <Button bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} as={Link} to='/Conclusion'>Send Email</Button>
            </div>
        </div>
    );
  };
  
export default ContextSix;